export type LogoProps = React.HTMLAttributes<SVGElement>;

export const Logo = (props: LogoProps) => (
	<svg
		fill="none"
		{...props}
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 320 280"
	>
		<path
			d="M96 31h91c65 0 107 46.5 107 109s-42 109-107 109H96"
			stroke="var(--logo-primary, #00566A)"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="36"
		/>
		<path
			d="M36 34h.01M36 105h.01M36 176h.01M36 247h.01"
			stroke="var(--logo-primary, #00566A)"
			strokeLinecap="round"
			strokeWidth="48"
		/>
		<path
			d="M112 105h72"
			stroke="currentColor"
			strokeLinecap="round"
			strokeWidth="12"
		/>
		<path
			d="M184 105v71h68"
			stroke="var(--logo-accent, #18DDEA)"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="14"
		/>
		<circle cx="112" cy="105" fill="currentColor" r="22" />
		<circle cx="184" cy="105" fill="currentColor" r="22" />
		<circle cx="112" cy="176" fill="currentColor" r="22" />
		<circle cx="184" cy="176" fill="var(--logo-accent, #18DDEA)" r="22" />
		<circle cx="252" cy="176" fill="var(--logo-accent, #18DDEA)" r="22" />
	</svg>
);
